import { GatekeeperStatus } from 'types/gatekeeper';
import { createActionWithPayload } from './helpers';

export const setStatus = (state: GatekeeperStatus) =>
  createActionWithPayload('@gatekeeper/SET_STATUS', state);

export type GatekeeperActions = ReturnType<typeof setStatus>;
